// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u0K7GW6P0hGkTUqgpNaE{flex-direction:column;gap:4px;display:flex}.rCn_NfgIYmYl9Tjx4OTC{align-items:center;gap:4px;display:flex}.HvDGONkS4wgOZxbahfTp{flex-direction:column;gap:2px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `u0K7GW6P0hGkTUqgpNaE`,
	"subtitle": `rCn_NfgIYmYl9Tjx4OTC`,
	"tooltipContent": `HvDGONkS4wgOZxbahfTp`
};
export default ___CSS_LOADER_EXPORT___;
